import { useContext } from 'react';

import { ViewAsContext, ViewAsContextValue } from './context';

function useViewAs(): ViewAsContextValue {
  const ctx = useContext(ViewAsContext);
  if (!ctx) {
    throw new Error('useViewAs must be used within a ViewAsProvider');
  }
  return ctx;
}

export default useViewAs;
